import React, { Component } from 'react';

import {
  Link
} from "react-router-dom";

class Header extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		let {type} = this.props
		return (
			<header className={type}>
				<div className="container-fluid top__bar">
					<nav className="navbar navbar-expand-lg navbar-primary p-0 pt-2">
						<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#menu" aria-controls="menu" aria-expanded="false" aria-label="Toggle navigation">
						<img className="menu__icon" src="../images/menu.png"/>
						</button>
						<div className="collapse navbar-collapse menu__left" id="menu">
							<ul className="navbar-nav mr-auto">
								<li className="nav-item has__component">
									<a className="nav-link" href="#learn">Learn</a>
									<ul className="navbar-nav mr-auto submenu d-none">
										<li className="nav-item">
											<a className="nav-link" href="#" title="">Who we are</a>
										</li>
										<li className="nav-item">
											<a className="nav-link" href="#" title="">Ingredients</a>
										</li>
										<li className="nav-item">
											<a className="nav-link" href="#" title="">Blog</a>
										</li>
										<li className="nav-item">
											<a className="nav-link" href="#" title="">Reviews</a>
										</li>
										<li className="nav-item">
											<a className="nav-link" href="#" title="">Gift</a>
										</li>
										<li className="nav-item">
											<a className="nav-link" href="#" title="">Subscription</a>
										</li>
									</ul>
								</li>
								<li className="nav-item">
									<Link className="nav-link" to="/product">Products</Link>
								</li>
							</ul>
						</div>
						
						<div className="menu__logo">
							<Link className="navbar-brand" to="/">
								<img src="../images/logo.svg"/>
							</Link>
						</div>
						
						<div className="menu__right">
							<Link to="/product-2" className="btn btn-primary d-none d-lg-inline-block">Personalise Now</Link>
							<a href="#">
								<svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M25.8451 20.9564C24.5596 19.6709 23.0296 18.7193 21.3602 18.1433C23.1482 16.9118 24.3228 14.8509 24.3228 12.5205C24.3228 8.75817 21.2619 5.69727 17.4996 5.69727C13.7373 5.69727 10.6764 8.75817 10.6764 12.5205C10.6764 14.8509 11.851 16.9118 13.639 18.1433C11.9696 18.7193 10.4396 19.6709 9.1541 20.9564C6.92494 23.1856 5.69727 26.1494 5.69727 29.3019H7.54138C7.54138 23.8109 12.0086 19.3437 17.4996 19.3437C22.9906 19.3437 27.4578 23.8109 27.4578 29.3019H29.3019C29.3019 26.1494 28.0742 23.1856 25.8451 20.9564ZM17.4996 17.4996C14.7541 17.4996 12.5205 15.266 12.5205 12.5205C12.5205 9.77497 14.7541 7.54138 17.4996 7.54138C20.2451 7.54138 22.4787 9.77497 22.4787 12.5205C22.4787 15.266 20.2451 17.4996 17.4996 17.4996Z" fill="white"/>
									<path d="M17.5 35C7.88462 35 0 27.1795 0 17.5C0 7.88461 7.82051 0 17.5 0C27.1154 0 35 7.82051 35 17.5C35 27.1154 27.1795 35 17.5 35ZM17.5 1.85897C8.91026 1.85897 1.85898 8.84615 1.85898 17.5C1.85898 26.0897 8.84616 33.141 17.5 33.141C26.0897 33.141 33.141 26.1538 33.141 17.5C33.141 8.91026 26.1538 1.85897 17.5 1.85897Z" fill="white"/>
								</svg>
							</a>
							<a href="#" className="d-none d-lg-inline-block">
								<svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M26.9951 24.7084L25.6359 9.26162C25.6068 8.91868 25.3204 8.65903 24.9854 8.65903H22.1893C22.1505 6.08211 20.0631 4 17.5 4C14.9369 4 12.8495 6.08211 12.8107 8.65903H10.0146C9.67476 8.65903 9.3932 8.91868 9.36408 9.26162L8.00485 24.7084C8.00485 24.728 8 24.7476 8 24.7672C8 26.526 9.59709 27.9565 11.5631 27.9565H23.4369C25.4029 27.9565 27 26.526 27 24.7672C27 24.7476 27 24.728 26.9951 24.7084ZM17.5 5.32275C19.3398 5.32275 20.8398 6.81207 20.8786 8.65903H14.1214C14.1602 6.81207 15.6602 5.32275 17.5 5.32275ZM23.4369 26.6338H11.5631C10.3301 26.6338 9.3301 25.8107 9.31068 24.7966L10.6117 9.98668H12.8058V11.9953C12.8058 12.3627 13.0971 12.6567 13.4612 12.6567C13.8252 12.6567 14.1165 12.3627 14.1165 11.9953V9.98668H20.8786V11.9953C20.8786 12.3627 21.1699 12.6567 21.534 12.6567C21.8981 12.6567 22.1893 12.3627 22.1893 11.9953V9.98668H24.3835L25.6893 24.7966C25.6699 25.8107 24.665 26.6338 23.4369 26.6338Z" fill="white" stroke="white" stroke-width="0.5"/>
									<path d="M17.5 35C7.88462 35 0 27.1795 0 17.5C0 7.88461 7.82051 0 17.5 0C27.1154 0 35 7.82051 35 17.5C35 27.1154 27.1795 35 17.5 35ZM17.5 1.85897C8.91026 1.85897 1.85898 8.84615 1.85898 17.5C1.85898 26.0897 8.84616 33.141 17.5 33.141C26.0897 33.141 33.141 26.1538 33.141 17.5C33.141 8.91026 26.1538 1.85897 17.5 1.85897Z" fill="white"/>
								</svg>
							</a>
						</div>
					</nav>
				</div>
				<div className="component--extended">
					<div className="container-fluid">
						<ul className="menu__left">
							<li className="nav-item">
								<a className="nav-link" href="#" title="">Who we are</a>
							</li>
							<li className="nav-item">
								<a className="nav-link" href="#" title="">Ingredients</a>
							</li>
							<li className="nav-item">
								<a className="nav-link" href="#" title="">Blog</a>
							</li>
							<li className="nav-item">
								<a className="nav-link" href="#" title="">Reviews</a>
							</li>
							<li className="nav-item">
								<a className="nav-link" href="#" title="">Gift</a>
							</li>
							<li className="nav-item">
								<a className="nav-link" href="#" title="">Subscription</a>
							</li>
						</ul>
					</div>
				</div>
			</header>
		);
	}
}

export default Header;